export const CHATBOX_TYPES = {
    PM: 'pm',
    LOBBY: 'lobby',
    TABLE: 'table',
    TABLE_MOBILE: 'table_mobile',
}